import { Loader } from "@circle-react-uikit/Loader";

interface LoaderRowProps {
  className?: string;
}

export const LoaderRow = ({ className = "" }: LoaderRowProps) => (
  <div className="flex w-full items-center justify-center">
    <Loader className={className} />
  </div>
);
